import { useAppContext } from '../contexts/AppContext'
import { BackendClient } from '@playbooks/core/src/services/BackendClient'

/**
 * Custom hook to create an instance of BackendClient with the necessary configuration.
 * @returns An instance of BackendClient
 */
export function usePlaybooksBackendClient() {
  const { config } = useAppContext()

  if (!config?.playbooksBackendUrl || (!config?.serviceBaseUrl && !config?.getBackendToken)) {
    console.warn(
      'Playbooks Backend configuration is missing. Provide playbooksBackendUrl and either getBackendToken or serviceBaseUrl in ActionCardsConfig.',
    )
  }

  const { playbooksBackendUrl, serviceBaseUrl, serviceAuthToken, getBackendToken } = config

  return new BackendClient({
    backendUrl: playbooksBackendUrl || undefined,
    // Hosts can supply their own authentication; legacy hosts exchange Meeting Service credentials.
    getBackendToken:
      getBackendToken ||
      (async () => {
        if (!serviceBaseUrl) throw new Error('Meeting Service base URL is not configured')
        const response = await fetch(`${serviceBaseUrl}/playbooks-token`, {
          method: 'POST',
          headers: serviceAuthToken ? { Authorization: `Bearer ${serviceAuthToken}` } : {},
        })
        if (!response.ok) throw new Error(`Failed to fetch Playbooks token: ${response.statusText}`)
        const data = (await response.json()) as { token: string }
        return data.token
      }),
  })
}
